import { collectTimings } from "./collectTimings";

collectTimings();
